import { CustomIcons } from '@ltvco/refresh-lib/theme';
import { type FilterTypeOption } from '@ltvco/refresh-lib/v1';
import {
  FacebookRounded,
  LinkedIn,
  Home,
  Person,
  Phone,
  Email,
  AlternateEmail,
  CloudUpload,
  Restore,
  List,
  NotificationsNone,
  PersonPinCircle,
  Redeem,
  MapRounded,
  AccountCircle,
  Summarize,
  Search,
  NotificationsActive,
  ManageAccounts,
  X,
  Radar,
} from '@mui/icons-material';

import { NWLogo } from 'icons';
import imgMigrationCta from 'images/img_migration_cta.svg';

import imgAnimatedPersonMagnifying from './images/ani_person_magnifying.gif';
import imgToggleToSatellite from './images/btn-map-satellite.png';
import imgToggleToStreet from './images/btn-map-street.png';
import imgCurrentOwner from './images/current-owner-icon.svg';
import earthquakeIcon from './images/earthquake.svg';
import imgCheckList from './images/icn_img_checklist.svg';
import imgIdHub from './images/id-hub.svg';
import ComplianceLogo from './images/img-alert.svg';
import imgAppleStore from './images/img-appstore.svg';
import imgCrimeFeedCTA from './images/img-crime-feed-cta.svg';
import imgDarkWebEmail from './images/img-dark-web-email.svg';
import imgGoogleStore from './images/img-google-play.svg';
import imgRadialProperty from './images/img-radial-property.svg';
import img24hr from './images/img_24hr.svg';
import imgAddressGeneric from './images/img_address_generic_no_bg.svg';
import imgAmenities from './images/img_amenities.svg';
import american_express from './images/img_amex.svg';
import imgAppStoreBadge from './images/img_apple_app_store_badge.svg';
import applePay from './images/img_apple_pay.svg';
import imgAreaPin from './images/img_areapin.svg';
import imgAttachmentJpg from './images/img_attachment_jpg.svg';
import imgAttachmentPdf from './images/img_attachment_pdf.svg';
import imgGooglePlayBadge from './images/img_badge_google_play.svg';
import imgBell from './images/img_bell.svg';
import imgMonitoringBell from './images/img_bell_monitoring.svg';
import imgBulkSearchDocument from './images/img_bulk_search_document.svg';
import imgBulkSearchHouse from './images/img_bulk_search_house.svg';
import imgCircleUser from './images/img_circle_user.svg';
import imgCloudDocumentLockBox from './images/img_cloud_document_lockbox.svg';
import imgComputerLimitReached from './images/img_computer_limit_reached.svg';
import imgContactlessIcon from './images/img_contactless_icon.svg';
import imgCopyIcon from './images/img_copy_icon.svg';
import imgCreateList from './images/img_create_list.svg';
import imgCustomerService from './images/img_customer_service.svg';
import imgDarkWebScan from './images/img_dark_web_scan.svg';
import discover from './images/img_discover.svg';
import imgEtagsLogo from './images/img_etags_logo.svg';
import imgExampleAircraft from './images/img_example_aircraft.svg';
import imgExampleAutomobile from './images/img_example_automobile.svg';
import imgExampleWatercraft from './images/img_example_watercraft.svg';
import imgExpiredEmailLink from './images/img_expired_email_link.svg';
import imgFallbackProperty from './images/img_fallback_property.svg';
import imgFraudCheck from './images/img_fraud_check.svg';
import genericCreditCard from './images/img_generic_credit_card.svg';
import googlePay from './images/img_google_pay.svg';
import imgMagnifyingGlassNoResultsPage from './images/img_magnifying_glass_no_results.svg';
import imgMapDefaultPin from './images/img_map_default_pin.png';
import imgMapMainHomePin from './images/img_map_main_home_pin.svg';
import imgMapSecondaryPin from './images/img_map_secondary_pin.svg';
import imgMarketTrends from './images/img_market_trends.svg';
import masterCard from './images/img_mastercard.svg';
import imgMobileExpIcon from './images/img_mobile_exp_icon.svg';
import imgMobileFreemium from './images/img_mobile_freemium.svg';
import imgNHFacts from './images/img_neighborhood_facts.svg';
import imgMonitorBanner from './images/img_neighborhood_safety.svg';
import paymentRequired from './images/img_payment_required.svg';
import paymentRequiredV2 from './images/img_payment_required_v2.svg';
import paypal from './images/img_paypal.svg';
import img_pdf_glow from './images/img_pdf_glow.svg';
import imgMapBoxPin from './images/img_pin.svg';
import imgPlaceholderSexOffender from './images/img_placeholder_sex_offender.svg';
import imgPremiumBadge from './images/img_premium_badge.svg';
import imgReportRating from './images/img_report_rating.svg';
import imgSaveHeart from './images/img_save_heart.svg';
import imgSaveListProperty from './images/img_save_list_property.svg';
import facebookLogo from './images/img_social_facebook.svg';
import linkedinLogo from './images/img_social_linkedin.svg';
import twitterLogo from './images/img_social_twitter.svg';
import imgSingleSignOnCta from './images/img_sso_cta.svg';
import imgSuccessfulUpgrade from './images/img_successful_upgrade.svg';
import imgUpdatesIcon from './images/img_updates_icon.svg';
import imgUploadAttachmentIcon from './images/img_upload_attachment_icon.svg';
import venmo from './images/img_venmo.svg';
import venmoButton from './images/img_venmo_button.svg';
import visa from './images/img_visa.svg';
import Bankrupticies from './images/imgBankruptcies.svg';
import ClaimedReport from './images/imgClaimedReport.svg';
import ClaimReport from './images/imgClaimReport.svg';
import Criminal from './images/imgCriminalTraffic.svg';
import MonitoringBell from './images/imgMonitoringBell.svg';
import Traffic from './images/imgTraffic.svg';
import landslideIcon from './images/landslide.svg';
import imgLayerTech from './images/LayerTech.svg';
import logoSmall from './images/logo-small.svg';
import logo from './images/logo.svg';
import neighborSpoofing from './images/neighbor-spoofing.svg';
import imgNoProperty from './images/no-property-img-fallback.svg';
import ownerSearchGenericCta from './images/owner-search-generic-cta.svg';
import premiumModalBannerMob1 from './images/premiumModal-banner-mob1.svg';
import premiumModalBannerMob2 from './images/premiumModal-banner-mob2.svg';
import premiumModalBanner from './images/premiumModal-banner.svg';
import premiumModalCrown from './images/premiumModal-crown.svg';
import premiumModalEmailIcon from './images/premiumModal-email.svg';
import premiumModalPersonIcon from './images/premiumModal-person.svg';
import premiumModalPhoneIcon from './images/premiumModal-phone.svg';
import relativeInsightIcon from './images/relative-insight-icon.svg';
import rewardsBannerDesktop from './images/rewards_banner_desktop.png';
import rewardsBannerMobile from './images/rewards_banner_mobile.png';
import rewardsCtaImage from './images/rewards_cta_image.svg';
import imgRocket from './images/rocket.svg';
import searchIcon from './images/search-icon.svg';
import SearchLogo from './images/search-logo.svg';
import imgSocialNW from './images/social-nw.svg';
import imgSpecializedBackgroundCheck from './images/specialized-background-check.svg';
import timPhoto from './images/sponsored-agent-photo-tim.png';
import yingPhoto from './images/sponsored-agent-photo-ying.png';
import generalPhoto from './images/sponsored-agent-photo.png';
import verificationEmail from './images/verification-email.svg';
import wildfireIcon from './images/wildfire.svg';

const baseUrl = `${window.location.protocol}//${window.location.host}`;
const reportTypeFilterOptions: { [key: string]: FilterTypeOption } = {
  monitored_report: {
    id: 'monitored_report',
    display: 'Monitored',
    eventLabel: 'Monitored',
  },
  detailed_person_report: {
    id: 'detailed_person_report',
    display: 'Person',
    eventLabel: 'Person',
  },
  reverse_phone_report: {
    id: 'reverse_phone_report',
    display: 'Phone',
    eventLabel: 'Phone',
  },
  property_report: {
    id: 'property_report',
    display: 'Property',
    eventLabel: 'Property',
  },
  social_network_report: {
    id: 'social_network_report',
    display: 'Email',
    eventLabel: 'Email',
  },
  username_report: {
    id: 'username_report',
    display: 'Username',
    eventLabel: 'Username',
  },
  sex_offender_report: {
    id: 'sex_offender_report',
    display: 'Neighborhood',
    eventLabel: 'Neighborhood',
  },
  phone_fraud_report: {
    id: 'phone_fraud_report',
    display: 'Phone Fraud',
    eventLabel: 'Phone Fraud',
  },
  email_fraud_report: {
    id: 'email_fraud_report',
    display: 'Email Fraud',
    eventLabel: 'Email Fraud',
  },
};

// TODO: should we extend the default config the same way we're doing with the theme? might be good for some props, other props maybe should be required
export const constants = {
  images: {
    astrology: {
      imgAstrologyNumerology: '',
      imgAstrologyNumerologyV2: '',
      imgAstrologyNumerologyLoading: '',
      compatibilityImg: '',
      aries: '',
      taurus: '',
      gemini: '',
      cancer: '',
      leo: '',
      virgo: '',
      libra: '',
      scorpio: '',
      sagittarius: '',
      capricorn: '',
      aquarius: '',
      pisces: '',
      empty: '',
      emptyBackground: '',
      smallAries: '',
      smallTaurus: '',
      smallGemini: '',
      smallCancer: '',
      smallLeo: '',
      smallVirgo: '',
      smallLibra: '',
      smallScorpio: '',
      smallSagittarius: '',
      smallCapricorn: '',
      smallAquarius: '',
      smallPisces: '',
      smallAscendant: '',
    },
    astrologyStandalone: {
      imgOnboardingBg: '',
      AstrologyIcon: '',
    },
    imgClaimReport: ClaimReport,
    imgClaimedReport: ClaimedReport,
    imgMonitoring: MonitoringBell,
    brandLogo: logo,
    brandLogoMobile: logoSmall,
    imgAppleStore,
    imgGoogleStore,
    master: masterCard,
    visa,
    american_express,
    discover,
    genericCreditCard,
    paypal,
    googlePay,
    paymentRequired,
    paymentRequiredV2,
    applePay,
    venmo,
    venmoButton,
    searchLogo: SearchLogo,
    searchIcon: searchIcon,
    complianceLogo: ComplianceLogo,
    imgDarkWebEmail,
    imgNoProperty,
    imgExampleAircraft,
    imgExampleWatercraft,
    imgExampleAutomobile,
    monitoringBell: imgMonitoringBell,
    imgIdHub,
    imgAddressGeneric,
    imgBell,
    imgDarkWebScan,
    imgSpecializedBackgroundCheck,
    imgSpecializedUnclaimedMoney: '',
    imgReportRating,
    imgSuccessfulUpgrade,
    imgComputerLimitReached,
    pdfLogo: img_pdf_glow,
    img24hr,
    neighborSpoofing,
    imgAnimatedPersonMagnifying,
    imgMagnifyingGlassNoResultsPage,
    imgMapDefaultPin,
    imgMapMainHomePin,
    imgMapSecondaryPin,
    imgMonitorBanner,
    imgMobileExpIcon,
    imgCopyIcon,
    imgContactlessIcon,
    imgUpdatesIcon,
    imgEtagsLogo,
    imgNHFacts,
    imgMarketTrends,
    imgAmenities,
    imgCheckList,
    imgAppStoreBadge,
    imgGooglePlayBadge,
    imgMobileFreemium,
    imgFraudCheck,
    ownershipHistoryImages: {
      imgCircleUser,
    },
    imgPremiumBadge,
    rewardsBannerMobile,
    rewardsBannerDesktop,
    rewardsCtaImage,
    imgMapBoxPin,
    imgAreaPin,
    imgCustomerService,
    imgExpiredEmailLink,
    imgFallbackProperty,
    imgPlaceholderSexOffender,
    imgNoVehicleImageProvided: '',
    imgNoticeLeave: '',
    imgToggleToSatellite,
    imgToggleToStreet,
    bulkSearchImages: {
      imgBulkSearchDocument,
      imgBulkSearchHouse,
    },
    imgSaveListProperty,
    imgSaveHeart,
    imgCreateList,
    imgLayerTech,
    imgRadialProperty,
    relativeInsightIcon,
    imgRocket,
    premiumModalCrown,
    premiumModalBanner,
    premiumModalBannerMob1,
    premiumModalBannerMob2,
    premiumModalPersonIcon,
    premiumModalPhoneIcon,
    premiumModalEmailIcon,
    sponsoredAgentPhoto: {
      timPhoto,
      yingPhoto,
      generalPhoto,
    },
    imgSingleSignOnCta,
    ownerSearchGenericCta,
    imgFlowerObituary: '',
    imgMigrationCta,
    CourtRecordsImages: {
      imgCriminal: Criminal,
      imgTraffic: Traffic,
      imgBankruptcies: Bankrupticies,
    },
    verificationEmail,
    imgCrimeFeedCTA,
    imgCurrentOwner,
    earthquakeIcon,
    landslideIcon,
    wildfireIcon,
    imgAttachmentJpg,
    imgAttachmentPdf,
    imgCloudDocumentLockBox,
    imgUploadAttachmentIcon,
  },
  links: {
    baseUrl: `${baseUrl}${
      import.meta.env.VITE_PATH_PREFIX?.includes('/')
        ? import.meta.env.VITE_PATH_PREFIX
        : `/${import.meta.env.VITE_PATH_PREFIX}`
    }`,
    joinLink: 'https://www.neighborwho.com/lp/ec88b4/5/subscribe',
    brandLink: import.meta.env.VITE_DEV_PROXY_SEARCH_PERSON_TEASER
      ? ''
      : `${baseUrl}`,
    aboutLink: 'https://www.neighborwho.com/about-us',
    fcraLink: 'https://www.neighborwho.com/fcra/',
    doDontsLink: 'https://www.neighborwho.com/dos-donts/',
    tosLink: 'https://www.neighborwho.com/terms-and-conditions/',
    privacyLink: 'https://www.neighborwho.com/privacy-policy/',
    contactLink: 'https://www.neighborwho.com/contact-us/',
    FaqLink: 'https://www.neighborwho.com/dos-donts/',
    dontSellInfoLink: 'https://www.neighborwho.com/app/optout/search',
    affiliateLink: 'https://www.neighborwho.com/affiliates/',
    peopleSearchLink: '',
    reversePhoneLink: '',
    emailLookupLink: '',
    reverseAddressLink: '',
    contactForm: 'https://www.neighborwho.com/contact-us/',
    supportLink: 'https://support.neighborwho.com/hc/en-us',
    twitterLink: 'https://twitter.com/UseNeighborWho',
    facebookLink: 'https://www.facebook.com/UseNeighborWho/',
    blogLink: 'https://www.neighborwho.com/blog/',
    brandIosUrl:
      'https://apps.apple.com/us/app/neighborwho-address-search/id6462454598',
    brandAndroidUrl:
      'https://play.google.com/store/apps/details?id=com.neighborwho.android',
    rapidsLookupLink: 'https://www.neighborwho.com/rpds/lookup',
    rapidsSmartLink: 'https://www.neighborwho.com/rpds/smart',
    etagsPartnerUrl: '',
    mrRogersBaseUrl: '/ss/mrg',
    billingLink: 'https://www.neighborwho.com/contact-us/',
    customPlanLink: 'https://forms.gle/nHPbYodcb3m5B1Cg6',
    mapboxStyleUrl: 'mapbox://styles/beenverified/cloywa73e00sd01qnb8162waw',
    dataDeckRootURI: 'hk/dd/v2',
    marketplaceBaseUrl: 'https://www.neighborwho.com/address-listings/',
    chatLink: 'https://www.neighborwho.com/chat/',
    topHapBaseUrl: 'https://widgets.tophap.com/api/widgets',
    monocleLeadsEndpoint: 'https://www.neighborwho.com/mcl/v1/leads',
    cancelSurveyLink:
      'https://docs.google.com/forms/d/e/1FAIpQLSdcCaumBFiVy4KvJ8sMFjXQHm-6ptUEg9MPdOWtsqcPmzxMpg/viewform',
    propertySummaryFeedbackLink:
      'https://docs.google.com/forms/d/e/1FAIpQLSeHmGuOSQDmkPxA_aSUvZmbhnZWOAUh6YZR4wVbd_CypR_5kQ/viewform',
    propertySmartInsightsSurvey: 'https://forms.gle/dZPstP3f2NYP9gDg8',
    propertyAdvertiseLink: 'https://forms.gle/7v5ZFryzVdYxavX98',
    setupSsoLink: 'https://www.neighborwho.com/sso_connections',
    reactivateLink: 'https://neighborwho.com/rf/reactivation',
    neighborhoodInsightsFeedbackLink:
      'https://docs.google.com/forms/d/1941a6A_AhHAczkO9IH1wVn-w2GvaWgjSd2f5Z8f0b74',
    flagCommentFormLink:
      'https://docs.google.com/forms/d/1PPDNxgUq4pxszCDZLYkcSI2RN4qhetMuG4nMlkk5_-k/edit',
  },
  featureFlags: {
    hasCriminalEnabled: false,
    propertyReportFlags: ['include_ca_data'],
    enableListExport: false,
    shouldOpenReportInCurrentTab: true,
    hasSmartInsightsAutoLoadEnabled: true,
    isReceiptPdfEnabled: true,
    relativesInsightsEnabled: false,
    shouldOpenNeighborhoodReport: true,
    hasReportAttachmentsEnabled: false,
  },
  data: {
    brandName: 'NeighborWho',
    brandAbbreviation: 'nw' as 'nw',
    brandSupportEmail: 'support@neighborwho.com',
    legalName: 'NeighborWho LLC',
    supportPhone: '1-866-202-7417',
    customerSupportPhone: '1-888-579-5910',
    supportEmail: 'support@neighborwho.com',
    complianceEmail: 'compliance@neighborwho.com',
    pdfPrice: '$4.95',
    rewardsDisclaimer:
      'Certain products and services, including vehicle purchase/sale opportunities, provided above include offers from third parties and/or external partners from whom we may receive limited compensation. Please be advised that these offers are provided as a convenience and are a sample, but do not necessarily include ALL offers, products or services available in the marketplace.',
    upgradePlanCustomSolutionHeading: 'Need more reports or users?',
    upgradePlanCustomSolutionDescription: 'Let’s talk',
    limitReachedSubHeading:
      'We offer different solutions to match your search needs',
    contactOptionsCustomPlanDisplay: 'Request larger plan',
    listHubProviderID: 'M-5387',
    listHubInternalSourceName: 'ltv-neighborwho-ldp',
    smartSearchFeedbackLink: 'https://forms.gle/ETZFBpVZAwkdtrKH8',
    blockUpgradeWindowThreshold: 24,
    premiumModalCardData: [
      {
        title: 'Person Search',
        icon: premiumModalPersonIcon,
        content:
          'Dive deeper with possible contact information, criminal & address history, etc.',
      },
      {
        title: 'Phone Search',
        icon: premiumModalPhoneIcon,
        content: 'See who might be behind the numbers',
      },
      {
        title: 'Email Search',
        icon: premiumModalEmailIcon,
        content: 'See who might be behind an email',
      },
    ],
    premiumModalContent:
      "Looks like you're missing out on key searches, like person search. Unlock premium data for access to person, phone, email, property, dark web, unclaimed money searches and more!",
    copyrightText:
      '© 2024 NeighborWho LLC. All rights reserved. NeighborWho® is a registered trademark of NeighborWho LLC',
    defaultSearchFormEventName: 'openPropertySearch',
    brandCustomerSupportSchedule: { days: 'Mon - Fri', hours: '9am - 6pm EST' },
    customerSupportAvailabilityHours: {
      email: 'Available 24 hours a day',
      chat: 'Chat available 24 hours a day via our AI assistant',
    },
    peopleSubSearches: ['person', 'contact'],
  },
  config: {
    socialMedia: [
      {
        textContent: 'X',
        alternateTextContent: '@neighborwho',
        href: 'https://x.com/UseNeighborWho',
        imgLogoUrl: twitterLogo,
        icon: <X fontSize="small" sx={{ color: '#1F2F64' }} />,
        hideOnSide: false,
      },
      {
        textContent: 'Facebook',
        alternateTextContent: 'facebook.com/NeighborWho',
        href: 'https://www.facebook.com/UseNeighborWho/',
        imgLogoUrl: facebookLogo,
        icon: <FacebookRounded sx={{ color: '#1F2F64', fontSize: '1.4rem' }} />,
        hideOnSide: false,
      },
      {
        textContent: 'Linkedin',
        alternateTextContent: 'linkedin.com/company/neighborwho',
        href: 'https://www.linkedin.com/company/neighborwho',
        imgLogoUrl: linkedinLogo,
        icon: <LinkedIn sx={{ color: '#1F2F64', fontSize: '1.4rem' }} />,
        hideOnSide: true,
      },
      {
        textContent: 'NeighborWho Blog',
        href: 'https://www.neighborwho.com/blog/',
        imgLogoUrl: imgSocialNW,
        icon: <NWLogo fontSize="medium" sx={{ color: '#1F2F64' }} />,
        hideOnSide: true,
      },
    ],
    searchTabs: [
      {
        displayName: 'Property',
        id: 'propertyTab',
        icon: <Home sx={{ color: '#1F2F64', fontSize: '1.4rem' }} />,
        class: '',
        internalTabs: [
          {
            label: 'Address Report',
            mobileLabel: 'Report',
            libFormComponentName: 'SearchPropertyForm',
            eventCategory: 'Property search',
            ga4EventType: 'property',
          },
          {
            label: 'For Sale',
            mobileLabel: 'Sale',
            libFormComponentName: 'SearchForSalePropertiesForm',
            eventCategory: 'For sale search',
            ga4EventType: 'for_sale',
          },
          {
            label: 'For Rent',
            mobileLabel: 'Rent',
            libFormComponentName: 'SearchForRentPropertiesForm',
            eventCategory: 'For rent search',
            ga4EventType: 'for_rent',
          },
          {
            label: 'Pre-foreclosure',
            mobileLabel: 'Pre-foreclosure',
            libFormComponentName: 'SearchPFCPropertiesForm',
            eventCategory: 'Pre-Foreclosure search',
            ga4EventType: 'pfc',
          },
        ],
      },
      {
        displayName: 'People',
        id: 'peopleTab',
        icon: <Person sx={{ color: '#1F2F64', fontSize: '1.4rem' }} />,
        class: 'noBorderBottom noBorderRight',
        internalTabs: [
          {
            label: 'Search By Name',
            mobileLabel: 'Name',
            libFormComponentName: 'SearchPersonForm',
            eventCategory: 'People Search',
            ga4EventType: 'person_name',
          },
          {
            label: 'Search By Address',
            mobileLabel: 'Address',
            libFormComponentName: 'SearchPersonByAddressForm',
            eventCategory: 'Person search by address',
            ga4EventType: 'people_address',
          },
        ],
      },
      {
        displayName: 'Phone',
        id: 'phoneTab',
        icon: <Phone sx={{ color: '#1F2F64', fontSize: '1.4rem' }} />,
        class: 'noBorderBottom noBorderRight',
      },
      {
        displayName: 'Email',
        id: 'emailTab',
        icon: <Email sx={{ color: '#1F2F64', fontSize: '1.4rem' }} />,
        class: 'noBorderRight',
      },
      {
        displayName: 'Username',
        id: 'usernameTab',
        icon: <AlternateEmail sx={{ color: '#1F2F64', fontSize: '1.4rem' }} />,
        class: '',
      },
    ],
    sideMenuItems: [
      {
        route: '/dashboard',
        icon: <Home sx={{ color: '#1F2F64' }} />,
        text: 'My Dashboard',
        name: 'dashboard',
        state: '',
        'data-cy': 'dashboard',
        ga4EventType: 'dashboard',
      },
      {
        route: '/dashboard/import-list',
        icon: <CloudUpload sx={{ color: '#1F2F64' }} />,
        text: 'Bulk Upload',
        name: 'importList',
        state: '',
        'data-cy': 'importList',
      },
      {
        route: '/dashboard/reports',
        icon: <Restore sx={{ color: '#1F2F64' }} />,
        text: 'Recent Reports',
        name: 'recentReports',
        state: '',
        'data-cy': 'recent_reports',
        ga4EventType: 'recent_reports',
      },
      {
        route: '/dashboard/lists',
        icon: <List sx={{ color: '#1F2F64' }} />,
        text: 'Saved Reports and Lists',
        state: '',
        name: 'lists',
        'data-cy': 'saved_reports_and_list',
        ga4EventType: 'lists',
      },
      {
        route: '/dashboard/monitoring',
        icon: <NotificationsNone sx={{ color: '#1F2F64' }} />,
        text: 'Monitoring',
        state: '',
        name: 'monitoring',
        ga4EventType: 'monitoring',
      },
      {
        route: '/search/owner',
        icon: <PersonPinCircle sx={{ color: '#1F2F64' }} />,
        text: 'Owner Search',
        state: '',
        name: 'owner_search',
        ga4EventType: 'owner_search',
      },
      {
        route: '/dashboard/dark-web',
        icon: <CustomIcons.DarkWebIcon sx={{ color: '#1F2F64' }} />,
        text: 'Dark Web Scan',
        state: '',
        name: 'darkWebScan',
        'data-cy': 'dark_web_scan',
        ga4EventType: 'dark_web',
      },
      {
        route: '/dashboard/rewards',
        icon: <Redeem sx={{ color: '#1F2F64' }} />,
        text: 'Member Perks',
        state: '',
        name: 'memberPerks',
      },
      {
        route: '/dashboard/neighborhood-report',
        icon: <MapRounded sx={{ color: '#1F2F64' }} />,
        text: 'Neighborhood Report',
        state: '',
        name: 'neighborhoodReport',
        ga4EventType: 'neighborhood_report',
      },
      {
        route: '/dashboard/billing',
        icon: <AccountCircle sx={{ color: '#1F2F64' }} />,
        text: 'My Account',
        state: '',
        name: 'myAccount',
        'data-cy': 'my_account',
        ga4EventType: 'my_account',
      },
    ],
    newBillingOptions: [
      {
        name: 'modify',
        display: 'Modify my account',
      },
      {
        name: 'cancel',
        display: 'Cancel my account',
      },
      {
        name: 'billing',
        display: 'Billing FAQ',
      },
      {
        name: 'upgrade',
        display: 'Upgrade my account',
      },
    ],
    reportTypeFilterOptions,
    higherConfidenceThreshold: 50,
    hardcodedPlans: [],
    useLLMPersonMaxRetries: 2,
  },
  keys: {
    rapidsAPIKey: import.meta.env.VITE_RAPIDS_API_KEY ?? '',
    mapboxKey: import.meta.env.VITE_MAPBOX_API_KEY ?? '',
    mrRogersAPIKey: import.meta.env.VITE_MR_ROGERS_API_KEY ?? '',
    streetViewStaticApiKey:
      import.meta.env.VITE_STREET_VIEW_STATIC_API_KEY ?? '',
    topHapApiKey: import.meta.env.VITE_TOP_HAP_API_KEY ?? '',
  },
  internationalPlanNames: {
    vinPlan: [],
    languagePlan: [],
  },
  paymentPremiumModalCardData: {
    premiumPlan:
      '54_99_1_month_nofree_afill_limit_50_freepdf_neighborwho_upsell_alldataaccess',
    premiumPlanAmount: '$54.99',
    premiumPlanReports: [
      'Person Reports',
      'Phone Reports',
      'Email Reports',
      'All Other Search Types',
    ],
    currentPlanReports: ['Address Reports', 'Pre-foreclosure & Listing Search'],
    premiumMessage:
      'to unlock additional search options of names, phones, addresses & more!',
    packagePrice: '$65.99',
    buttonColor: '#1F2F64',
  },
  migrationPlanNames: [
    '22_86_1_month_nofree_afill_limit100reports_freepdf_neighborwho_plan_migration',
  ],
  dataCollections: {},
};

export const searchTabsForNewDesign = [
  {
    displayName: 'Property',
    id: 'propertyTab',
    icon: <Home sx={{ color: '#000', fontSize: '1.4rem' }} />,
    class: 'noBorderBottom',
    internalTabs: [
      {
        label: 'Address Report',
        mobileLabel: 'Report',
        libFormComponentName: 'SearchPropertyForm',
        eventCategory: 'property',
      },
      {
        label: 'Pre-foreclosure',
        mobileLabel: 'Pre-foreclosure',
        libFormComponentName: 'SearchPFCPropertiesForm',
        eventCategory: 'Pre-Foreclosure',
      },
    ],
  },
  {
    displayName: 'People',
    id: 'peopleTab',
    icon: <Person sx={{ color: '#000', fontSize: '1.4rem' }} />,
    class: 'noBorderBottom noBorderRight',
    internalTabs: [
      {
        label: 'Search By Name',
        mobileLabel: 'Name',
        libFormComponentName: 'SearchPersonForm',
        eventCategory: 'People Search',
      },
      {
        label: 'Search By Address',
        mobileLabel: 'Address',
        libFormComponentName: 'SearchPersonByAddressForm',
        eventCategory: 'Person search by address',
      },
    ],
  },
  {
    displayName: 'Phone',
    id: 'phoneTab',
    icon: <Phone sx={{ color: '#000', fontSize: '1.4rem' }} />,
    class: 'noBorderBottom noBorderRight',
    internalTabs: [
      {
        label: 'Search By Phone Number',
        mobileLabel: 'Phone Number',
        libFormComponentName: 'SearchPhoneForm',
        eventCategory: 'Phone Search',
      },
    ],
  },
  {
    displayName: 'Email',
    id: 'emailTab',
    icon: <Email sx={{ color: '#000', fontSize: '1.4rem' }} />,
    class: 'noBorderRight',
    internalTabs: [
      {
        label: 'Search By Email',
        mobileLabel: 'Email',
        libFormComponentName: 'SearchEmailForm',
        eventCategory: 'Email Search',
      },
    ],
  },
  {
    displayName: 'Username',
    id: 'usernameTab',
    icon: <AlternateEmail sx={{ color: '#000', fontSize: '1.4rem' }} />,
    class: 'noBorderRight',
    internalTabs: [
      {
        label: 'Search By Username',
        mobileLabel: 'Username',
        libFormComponentName: 'SearchUsernameForm',
        eventCategory: 'Username Search',
      },
    ],
  },
];

export const sideMenuItemsForNewDesign = [
  {
    route: '/dashboard',
    icon: <Home sx={{ fontSize: '24px', color: '#1F2F64' }} />,
    text: 'My Dashboard',
    name: 'dashboard',
    state: '',
    'data-cy': 'dashboard',
  },
  {
    route: '',
    icon: <Summarize sx={{ fontSize: '24px', color: '#1F2F64' }} />,
    text: 'Reports',
    name: 'reports',
    state: '',
    'data-cy': 'reports',
    childItems: [
      {
        route: '/dashboard/reports',
        icon: <Restore sx={{ fontSize: '24px', color: '#1F2F64' }} />,
        text: 'Recent Reports',
        name: 'recentReports',
        state: '',
        'data-cy': 'recent_reports',
      },
      {
        route: '/dashboard/lists',
        icon: <List sx={{ fontSize: '24px', color: '#1F2F64' }} />,
        text: 'Saved Reports and Lists',
        state: '',
        name: 'lists',
        'data-cy': 'saved_reports_and_list',
      },
      {
        route: '/dashboard/neighborhood-report',
        icon: <MapRounded sx={{ fontSize: '24px', color: '#1F2F64' }} />,
        text: 'Neighborhood Report',
        state: '',
        name: 'neighborhoodReport',
      },
    ],
  },
  {
    route: '',
    icon: <Search sx={{ fontSize: '24px', color: '#1F2F64' }} />,
    text: 'More Searches',
    state: '',
    name: 'more-searches',
    childItems: [
      {
        route: '/dashboard/import-list',
        icon: <CloudUpload sx={{ color: '#1F2F64' }} />,
        text: 'Bulk Upload',
        name: 'importList',
        state: '',
        'data-cy': 'importList',
      },
      {
        route: '/search/owner',
        icon: <PersonPinCircle sx={{ color: '#1F2F64' }} />,
        text: 'Owner Search',
        state: '',
        name: 'owner_search',
        'data-cy': 'owner_search',
      },
      {
        route: '/dashboard/fraud',
        icon: <Radar sx={{ color: '#1F2F64' }} />,
        text: 'FraudScan',
        state: '',
        name: 'fraudScan',
        'data-cy': 'fraud_scan',
      },
    ],
  },
  {
    route: '',
    icon: <NotificationsActive sx={{ fontSize: '24px', color: '#1F2F64' }} />,
    text: 'Monitoring Hub',
    state: '',
    name: 'monitoring-hub',
    childItems: [
      {
        route: '/dashboard/monitoring',
        icon: <NotificationsNone sx={{ fontSize: '24px', color: '#1F2F64' }} />,
        text: 'Monitoring',
        state: '',
        name: 'monitoring',
      },
      {
        route: '/dashboard/dark-web',
        icon: (
          <CustomIcons.DarkWebIcon
            sx={{ fontSize: '24px', color: '#1F2F64' }}
          />
        ),
        text: 'Dark Web',
        state: '',
        name: 'darkWebScan',
        'data-cy': 'dark_web_scan',
      },
    ],
  },
  {
    route: '',
    icon: <ManageAccounts sx={{ fontSize: '24px', color: '#1F2F64' }} />,
    text: 'My Profile',
    state: '',
    name: 'my-profile',
    childItems: [
      {
        route: '/dashboard/billing',
        icon: <AccountCircle sx={{ fontSize: '24px', color: '#1F2F64' }} />,
        text: 'My Account',
        state: '',
        name: 'myAccount',
        'data-cy': 'my_account',
      },
      {
        route: '/dashboard/rewards',
        icon: <Redeem sx={{ fontSize: '24px', color: '#1F2F64' }} />,
        text: 'Member Perks',
        state: '',
        name: 'memberPerks',
      },
    ],
  },
];
